import React, { useState } from 'react';
import axios from 'axios';

const Checkout = () => {
  const [loading, setLoading] = useState(false);

  const handlePayment = async () => {
    setLoading(true);

    try {
      // 1. Panggil API Backend Laravel untuk mendapatkan Snap Token
      const response = await axios.post('http:///192.168.18.2:8000/api/v1/payment/checkout', {
        amount: 150000, // Sesuaikan dengan nominal tagihan
        name: 'Pelanggan Radius Trend',
        email: 'user@radiustrend.com',
      });

      const snapToken = response.data.snap_token;

      // 2. Cek ketersediaan SDK Midtrans Snap lalu tampilkan Pop-up
      if (window.snap) {
        window.snap.pay(snapToken, {
          onSuccess: function (result) {
            console.log('Success:', result);
            alert('Pembayaran Berhasil!');
          },
          onPending: function (result) {
            console.log('Pending:', result);
            alert('Menunggu Pembayaran!');
          },
          onError: function (result) {
            console.log('Error:', result);
            alert('Pembayaran Gagal!');
          },
          onClose: function () {
            alert('Pop-up pembayaran ditutup sebelum transaksi selesai.');
          },
        });
      } else {
        alert('Midtrans Snap SDK belum siap. Periksa koneksi atau script di index.html');
      }
    } catch (error) {
      console.error('Gagal memproses pembayaran:', error);
      alert('Terjadi kesalahan saat memanggil server Laravel.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white p-4">
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-8 max-w-md w-full shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-2">Bayar Tagihan</h2>
        <p className="text-slate-400 text-sm mb-6">
          Klik tombol di bawah untuk membuka metode pembayaran Midtrans.
        </p>

        <button
          onClick={handlePayment}
          disabled={loading}
          className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-500 disabled:bg-slate-600 text-white font-semibold rounded-lg shadow-md transition duration-200"
        >
          {loading ? 'Memproses Token...' : 'Bayar Sekarang'}
        </button>
      </div>
    </div>
  );
};

export default Checkout;